import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './WhatsAppGroupsPage.css';

const WhatsAppGroupsPage = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState(''); // State for search term

  // Form State
  const [groupName, setGroupName] = useState('');
  const [courseName, setCourseName] = useState('');
  const [courseCode, setCourseCode] = useState('');
  const [semesterName, setSemesterName] = useState('');
  const [teacherName, setTeacherName] = useState('');
  const [slot, setSlot] = useState('');
  const [link, setLink] = useState('');
  const [submittedBy, setSubmittedBy] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  // Fetch groups
  useEffect(() => {
    const loadGroups = async () => {
      try {
        setLoading(true); setError('');
        const res = await axios.get(`${apiUrl}/api/whatsapp-groups`);
        setGroups(res.data);
      } catch (err) {
        console.error('Error fetching groups:', err);
        setError('Failed to load groups. Please try refreshing.');
      } finally { setLoading(false); }
    };
    loadGroups();
  }, [apiUrl]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!groupName || !link) {
        alert('Group Name and Link are required.'); return;
    }
    if (!link.includes('chat.whatsapp.com')) {
        alert('Please enter a valid WhatsApp group invite link.'); return;
    }
    setSubmitting(true); setError('');
    try {
        const newGroup = { groupName, courseName, courseCode, semesterName, teacherName, slot, link, submittedBy };
        const res = await axios.post(`${apiUrl}/api/whatsapp-groups`, newGroup);
        setGroups([res.data, ...groups]);
        setGroupName(''); setCourseName(''); setCourseCode(''); setSemesterName('');
        setTeacherName(''); setSlot(''); setLink(''); setSubmittedBy('');
    } catch (err) {
        console.error('Error posting group:', err.response?.data || err);
        setError(err.response?.data?.message || 'Failed to post group link.');
    } finally { setSubmitting(false); }
  };

  // Handle deletion
  // const handleDelete = async (groupId) => {
  //   if (!window.confirm('Are you sure?')) return;
  //   try {
  //       await axios.delete(`${apiUrl}/api/whatsapp-groups/${groupId}`);
  //       setGroups(groups.filter(group => group._id !== groupId));
  //   } catch (err) {
  //       console.error('Error deleting:', err.response?.data || err);
  //       alert(err.response?.data?.message || 'Failed to delete.');
  //   }
  // };

  // --- Filter Logic ---
  const filteredGroups = groups.filter(group => {
    const search = searchTerm.toLowerCase();
    // Check against all relevant fields, using optional chaining (?.) for safety
    return (
        group.groupName?.toLowerCase().includes(search) ||
        group.courseName?.toLowerCase().includes(search) ||
        group.courseCode?.toLowerCase().includes(search) ||
        group.semesterName?.toLowerCase().includes(search) ||
        group.teacherName?.toLowerCase().includes(search) ||
        group.slot?.toLowerCase().includes(search)
    );
  });
  // -----------------------

  return (
    <div className="whatsapp-groups-container">
      {/* --- Column 1: Form --- */}
      <div className="whatsapp-groups-form-card">
        <h3>Add WhatsApp Group</h3>
        <form onSubmit={handleSubmit}>
          {/* --- Form Input Fields --- */}
          <div className="form-group"><label htmlFor="groupName">Group Name *</label><input type="text" id="groupName" value={groupName} onChange={(e) => setGroupName(e.target.value)} required /></div>
          <div className="form-group"><label htmlFor="courseName">Course Name</label><input type="text" id="courseName" value={courseName} onChange={(e) => setCourseName(e.target.value)} placeholder="e.g., Data Structures" /></div>
          <div className="form-group"><label htmlFor="courseCode">Course Code</label><input type="text" id="courseCode" value={courseCode} onChange={(e) => setCourseCode(e.target.value)} placeholder="e.g., CSE4001" /></div>
          <div className="form-group"><label htmlFor="semesterName">Semester</label><input type="text" id="semesterName" value={semesterName} onChange={(e) => setSemesterName(e.target.value)} placeholder="e.g., Fall 2025-26" /></div>
          <div className="form-group"><label htmlFor="teacherName">Teacher Name</label><input type="text" id="teacherName" value={teacherName} onChange={(e) => setTeacherName(e.target.value)} placeholder="e.g., Dr. XYZ" /></div>
          <div className="form-group"><label htmlFor="slot">Slot</label><input type="text" id="slot" value={slot} onChange={(e) => setSlot(e.target.value)} placeholder="e.g., A11 " /></div>
          <div className="form-group"><label htmlFor="link">WhatsApp Invite Link *</label><input type="url" id="link" value={link} onChange={(e) => setLink(e.target.value)} placeholder="https://chat.whatsapp.com/..." required /></div>
          <div className="form-group"><label htmlFor="submittedBy">Your Name (Optional)</label><input type="text" id="submittedBy" value={submittedBy} onChange={(e) => setSubmittedBy(e.target.value)} /></div>

          {error && <p className="form-error">{error}</p>}
          <button type="submit" className="btn-submit-group" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Add Group Link'}
          </button>
        </form>
      </div>

      {/* --- Column 2: Group List --- */}
      <div className="whatsapp-groups-list-container">
        <h3>Unofficial Group Links</h3>
        <p className="disclaimer">Note: These links are submitted by users. Join groups at your own discretion.</p>

        {/* --- Search Input --- */}
        <div className="search-bar-container">
          <input
            type="text"
            placeholder="Search groups by name, course, teacher, slot..."
            className="group-search-bar"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {/* ------------------ */}

        {loading && <div className="loading-spinner">Loading groups...</div>}
        {!loading && groups.length === 0 && <p>No group links added yet.</p>}
        {/* --- Handle No Search Results --- */}
        {!loading && groups.length > 0 && filteredGroups.length === 0 && (
          <p className="no-results-text">No groups found matching "{searchTerm}".</p>
        )}
        {/* ------------------------------- */}

        {!loading && filteredGroups.length > 0 && (
          <div className="group-list">
            {/* --- Map over filteredGroups --- */}
            {filteredGroups.map(group => (
              <div key={group._id} className="group-card">
                <h4>{group.groupName}</h4>
                 <div className="group-card-details">
                    {group.courseName && <span className="group-detail-item">Course: {group.courseName} {group.courseCode && `(${group.courseCode})`}</span>}
                    {group.semesterName && <span className="group-detail-item">Sem: {group.semesterName}</span>}
                    {group.teacherName && <span className="group-detail-item">Teacher: {group.teacherName}</span>}
                    {group.slot && <span className="group-detail-item">Slot: {group.slot}</span>}
                 </div>
                <a href={group.link} target="_blank" rel="noopener noreferrer" className="group-link-button">
                  Join Group
                </a>
                {group.submittedBy && <p className="group-submitted-by">Added by: {group.submittedBy}</p>}
                <p className="group-date">Added: {new Date(group.createdAt).toLocaleDateString()}</p>
                 {/* <button className="btn-delete-group" onClick={() => handleDelete(group._id)}>
                   Delete
                 </button> */}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsAppGroupsPage;